import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "./data";

export const OrderCTA = () => (
  <section className="border-t border-[#A07E1F]/10 bg-[#F3EEE2]" data-testid="order-cta-section">
    <div className="mx-auto flex max-w-7xl flex-col items-start gap-8 px-5 py-20 sm:px-8 sm:py-24 lg:flex-row lg:items-center lg:justify-between">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: [0.33, 1, 0.68, 1] }}
        className="max-w-2xl"
      >
        <p className="mb-4 flex items-center gap-3 font-mono-accent text-[11px] uppercase tracking-[0.35em] text-[#A07E1F]">
          <span className="inline-block h-2 w-2 rotate-45 bg-[#D4AF37]" />
          Ready When You Are
        </p>
        <h2 className="font-serif-display text-3xl font-medium leading-tight tracking-tight text-[#12294D] sm:text-5xl">
          Place your order in two minutes — <span className="italic text-[#A07E1F]">pay securely online.</span>
        </h2>
        <p className="mt-4 text-base leading-relaxed text-[#46586F]">
          Choose your service, see your exact price instantly, and check out through our encrypted
          payment gateway. Your expert starts the moment payment confirms.
        </p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.15, ease: [0.33, 1, 0.68, 1] }}
        className="flex flex-col gap-3 sm:flex-row lg:flex-col"
      >
        <Link
          to="/order"
          data-testid="order-cta-button"
          className="group flex items-center justify-center gap-3 rounded-full bg-[#D4AF37] px-10 py-4 font-mono-accent text-xs font-bold uppercase tracking-[0.2em] text-[#12294D] transition-colors duration-300 hover:bg-[#C9A227]"
        >
          Order Now
          <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="order-cta-whatsapp"
          className="flex items-center justify-center gap-3 rounded-full border border-[#A07E1F]/50 px-10 py-4 font-mono-accent text-xs uppercase tracking-[0.2em] text-[#A07E1F] transition-colors duration-300 hover:bg-[#D4AF37]/15"
        >
          <MessageCircle size={16} /> Ask a Question First
        </a>
      </motion.div>
    </div>
  </section>
);
